// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["./extensions/ww_teaser/Resources/Private/app/TeaserFetchRequest.ts"].call(__webpack_exports__);
